<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Configuración del directorio" />
    <base-material-card
      color="indigo"
      icon="mdi-book-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          :loading="loadingForm"
          dark
          class="mb-2"
          @click.stop="save()"
          >Guardar</v-btn
        >
        <v-spacer />
      </v-toolbar>
      <v-tabs
        vertical
        background-color="deep-purple accent-4"
        center-active
        dark
        v-model="tab"
      >
        <v-tab key="general">General</v-tab>
        <v-tab key="restaurantes">Restaurantes</v-tab>
        <v-tab key="multiple">Multiple</v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item key="general">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">General</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row class="pa-4">
                <v-col cols="12" sm="6" md="4">
                  <v-checkbox
                    v-model="directorioConf.multipleAcepta"
                    label="Acepta Multiple"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="directorioConf.multipleAcepta"
                >
                  <v-checkbox
                    label="Multiple exclusivo"
                    v-model="directorioConf.multipleExclusivo"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="directorioConf.multipleExclusivo"
                >
                  <v-select
                    label="Multiple exclusivo"
                    v-model="directorioConf.multipleExclusivoGrupo"
                    :items="directorioConf.gruposAceptaMultiple"
                    item-text="nombre"
                    item-value="id"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="restaurantes">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text"
                  >RESTAURANTES
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="pa-4">
                <v-chip-group
                  column
                  v-model="restaurantes"
                  multiple
                  active-class="primary"
                >
                  <v-chip
                    v-for="r in restaurantesTodo"
                    :key="r.id"
                    :value="r.id"
                    outlined
                  >
                    {{ r.id }}
                    <v-icon
                      class="ml-2"
                      @click.stop="
                        $router.push(
                          '/admin/gest/' + r.negocio + '/restaurantes'
                        )
                      "
                      >mdi-pencil</v-icon
                    >
                  </v-chip>
                </v-chip-group>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card-title>Negocios</v-card-title>
                </v-col>
                <v-col cols="12">
                  <v-chip
                    disabled
                    v-for="r in negocios"
                    :key="r"
                    :value="r"
                    class="mx-2"
                  >
                    {{ r }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item key="multiple">
            <v-card class="px-4">
              <v-toolbar color="primary" dense>
                <v-toolbar-title class="white--text">Multiple</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-row class="pa-4">
                <v-col cols="12" v-if="directorioConf.multipleAcepta">
                  <v-data-table
                    :headers="headers"
                    :items="directorioConf.gruposAceptaMultiple"
                    :loading="loading"
                    :search="search"
                    disable-pagination:loading="loading"
                  >
                    <template v-slot:top>
                      <v-btn @click="dialog = true">
                        Añadir conjunto multiple
                      </v-btn>
                    </template>
                    <template v-slot:item.acciones="{ item }">
                      <v-card-actions class="pa-0 ma-0">
                        <v-spacer></v-spacer>
                        <v-btn
                          class="px-2 ml-1"
                          color="primary"
                          min-width="0"
                          small
                          @click="sincronizarDialogMetodo(item)"
                        >
                          <v-icon small>mdi-sync</v-icon>
                        </v-btn>
                        <v-btn
                          class="px-2 ml-1"
                          color="success"
                          min-width="0"
                          small
                          @click="editItemDialog(item)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          @click="deleteGrupo(item)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </base-material-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-row wrap>
              <v-col cols="12" v-if="itemGrupoRestaurantes.id">
                <v-text-field
                  disabled
                  v-model="itemGrupoRestaurantes.id"
                  label="Id"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="itemGrupoRestaurantes.nombre"
                  label="Nombre"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="itemGrupoRestaurantes.descripcion"
                  label="Descripcion"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  v-model="itemGrupoRestaurantes.restaurantes"
                  :items="itemsRestauranteAceptanPedidoConjunto"
                  label="Restaurantes aceptan pedido conjunto"
                  multiple
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="itemGrupoRestaurantes.restauranteMatriz"
                  @change="cambioRestauranteMatriz"
                  :items="itemsRestauranteAceptanPedidoConjuntoMatriz"
                  label="Restaurante matriz"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="itemGrupoRestaurantes.negocioMatriz"
                  :items="itemsRestauranteAceptanPedidoConjuntoMatriz"
                  readonly
                  label="Negocio matriz"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveGrupo"
            :loading="loadingForm"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sincronizarDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Sincronización en el grupo {{ sincronizarGrupo.nombre }}</span
          >
          <v-card-subtitle
            >Restaurante matriz
            {{ sincronizarGrupo.restauranteMatriz }}</v-card-subtitle
          >
        </v-card-title>

        <v-card-text>
          <v-list shaped>
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item-group
                  v-model="sincronizacionConf.valores"
                  multiple
                >
                  <template v-for="(item, i) in valoresSincronizar">
                    <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                    <v-list-item
                      v-else
                      :key="`item-${i}`"
                      :value="item.value"
                      active-class="deep-purple--text text--accent-4"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="item.text"
                          ></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="deep-purple accent-4"
                          ></v-checkbox>
                        </v-list-item-action>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-chip-group
                  v-if="Array.isArray(sincronizarGrupo.restaurantes)"
                  column
                  v-model="sincronizacionConf.restaurantes"
                  multiple
                  active-class="primary"
                >
                  <v-chip
                    v-for="r in sincronizarGrupo.restaurantes.filter(
                      (r) => r != sincronizarGrupo.restauranteMatriz
                    )"
                    :key="r"
                    :value="r"
                    outlined
                  >
                    {{ r }}
                  </v-chip>
                </v-chip-group>
              </v-col></v-row
            >
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="sincronizarDialog = false"
            >Cancelar</v-btn
          >
          <v-spacer />

          <v-btn
            color="blue darken-1"
            text
            @click="sincronizarMetodo"
            :loading="loadingForm"
            >Sincronizar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createSlug } from "@/utils/utils.js";
import { mapState } from "vuex";
import { db } from "../../firebase";
export default {
  data() {
    return {
      tab: 0,
      loadingForm: false,
      restaurantes: [],
      negocios: [],
      directorioConf: {
        gruposAceptaMultiple: [],
      },
      loading: false,
      search: "",
      itemGrupoRestaurantes: {
        id: null,
        nombre: "",
        descripcion: "",
        restaurantes: [],
        // cuentaStripe: "",
        restauranteMatriz: null,
        negocioMatriz: null,
      },
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Restaurantes",
          value: "restaurantes",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      //sincronizar
      sincronizarDialog: false,
      sincronizarGrupo: {},
      sincronizacionConf: {
        valores: [],
        restaurantes: [],
      },
    };
  },
  watch: {
    loadingDirectorio(v) {
      if (!v) this.initConfiguracion();
    },
    dialog(val) {
      val || this.close();
    },
    restaurantes(v) {
      const _vm = this;
      if (v.length > 0)
        this.negocios = [
          ...new Set(
            v
              .map((r) => {
                var found = _vm.restaurantesTodo.find((rest) => rest.id == r);
                if (found) {
                  return found.negocio;
                } else {
                  return;
                }
              })
              .filter((r) => !!r)
          ),
        ];
    },
  },
  computed: {
    ...mapState({
      directorio: (state) => state.app.directorioGest,
      loadingDirectorio: (state) => state.app.loadingNegocioGest,
    }),
    valoresSincronizar() {
      return [
        { text: "Horarios", value: "horarios" },
        { text: "Zonas de reparto", value: "zonas" },
        { text: "Configuracion", value: "configuracion" },
      ];
    },
    restaurantesTodo() {
      return this.$store.state.restaurantes.restaurantesTodosArray;
    },
    formTitle() {
      return !!this.itemGrupoRestaurantes.id
        ? "Editar Conjunto Multiple"
        : "Nuevo Conjunto Multiple";
    },
    itemsRestauranteAceptanPedidoConjunto() {
      return this.$store.state.restaurantes.restaurantesDirectorio.map((r) => {
        return {
          text: r.id,
          value: r.id,
        };
      });
    },
    itemsRestauranteAceptanPedidoConjuntoMatriz() {
      return this.itemsRestauranteAceptanPedidoConjunto.filter((r) =>
        this.itemGrupoRestaurantes.restaurantes.includes(r.value)
      );
    },

    gruposAceptaMultiple() {
      return this.directorioConf.gruposAceptaMultiple
        ? this.directorioConf.gruposAceptaMultiple
        : [];
    },
  },
  methods: {
    sincronizarMetodo() {
      this.loadingForm = true;
      console.log(this.sincronizacionConf);
      db.collection("restaurantes")
        .doc(this.sincronizarGrupo.restauranteMatriz)
        .get()
        .then((r) => {
          let datos = r.data();
          let datosGrabar = {};
          console.log(datos);
          if (this.sincronizacionConf.valores.includes("configuracion"))
            datosGrabar.confGeneral = datos.confGeneral;
          if (this.sincronizacionConf.valores.includes("horarios"))
            datosGrabar.horarios = datos.horarios;
          if (this.sincronizacionConf.valores.includes("zonas"))
            datosGrabar.zonasReparto = datos.zonasReparto;
          console.log(datosGrabar);

          return Promise.all(
            this.sincronizacionConf.restaurantes.map((rest) => {
              console.log(rest);
              return db
                .collection("restaurantes")
                .doc(rest)
                .set(datosGrabar, { merge: true });
            })
          );
        })
        .then(() => {
          this.sincronizarDialog = false;
        })
        .finally(() => (this.loadingForm = false));
    },
    sincronizarDialogMetodo(grupo) {
      this.sincronizarDialog = true;
      this.sincronizarGrupo = JSON.parse(JSON.stringify(grupo));
    },

    initConfiguracion() {
      this.$store.dispatch("restaurantes/getTodosRestaurantes");
      this.directorioConf =
        this.$store.state.app.directorioObjGest &&
        this.$store.state.app.directorioObjGest.configuracion
          ? this.$store.state.app.directorioObjGest.configuracion
          : {
              gruposAceptaMultiple: [],
            };
      this.restaurantes =
        this.$store.state.app.directorioObjGest &&
        this.$store.state.app.directorioObjGest.restaurantes
          ? this.$store.state.app.directorioObjGest.restaurantes
          : [];
      this.negocios =
        this.$store.state.app.directorioObjGest &&
        this.$store.state.app.directorioObjGest.negocios
          ? this.$store.state.app.directorioObjGest.negocios
          : [];
      if (!this.directorioConf.gruposAceptaMultiple)
        this.directorioConf.gruposAceptaMultiple = [];
    },
    cambioRestauranteMatriz() {
      this.itemGrupoRestaurantes.negocioMatriz =
        this.$store.state.restaurantes.restaurantesDirectorio.find(
          (r) => r.id == this.itemGrupoRestaurantes.restauranteMatriz
        ).negocio;
    },
    close() {
      this.dialog = false;
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    editItemDialog(item) {
      this.dialog = true;
      this.itemGrupoRestaurantes = JSON.parse(JSON.stringify(item));
    },
    reiniciarDatos() {
      this.itemGrupoRestaurantes = {
        id: null,
        nombre: "",
        descripcion: "",
        restaurantes: [],
        restauranteMatriz: null,
      };
    },
    deleteGrupo(item) {
      this.$confirm("¿Quiere elminar el grupo?", {
        buttonTrueText: "Si",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((res) => {
          if (res) {
            let foundIndex = this.directorioConf.gruposAceptaMultiple.findIndex(
              (g) => g.id == item.id
            );
            if (foundIndex > -1)
              this.directorioConf.gruposAceptaMultiple.splice(foundIndex, 1);
          } else {
            return Promise.reject("cancelar");
          }
        })
        .then((r) => {})
        .catch((e) => {
          if (e != "cancelar") {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al imprimir el ticket: " + e,
            });
          }
        })
        .finally();
    },
    saveGrupo() {
      if (this.itemGrupoRestaurantes.id) {
        //editando
        let foundIndex = this.directorioConf.gruposAceptaMultiple.findIndex(
          (g) => g.id == this.itemGrupoRestaurantes.id
        );
        if (foundIndex > -1) {
          let aux = JSON.parse(
            JSON.stringify(this.directorioConf.gruposAceptaMultiple)
          );
          aux[foundIndex] = this.itemGrupoRestaurantes;
          this.directorioConf.gruposAceptaMultiple = aux;
        }
      } else {
        //añadiendo
        this.itemGrupoRestaurantes.id = createSlug(
          this.itemGrupoRestaurantes.nombre
        );
        if (this.directorioConf.gruposAceptaMultiple.length > 0) {
          this.directorioConf.gruposAceptaMultiple.push(
            this.itemGrupoRestaurantes
          );
        } else {
          this.directorioConf.gruposAceptaMultiple = [
            this.itemGrupoRestaurantes,
          ];
        }
        this.$forceUpdate();
      }
      this.dialog = false;
    },
    save() {
      this.$store
        .dispatch("directorios/saveDirectorio", {
          id: this.$store.state.app.directorioGest,
          configuracion: this.directorioConf,
          restaurantes: this.restaurantes,
          negocios: this.negocios,
        })
        .then((res) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Directorio grabado con éxito",
          });
          // this.getDirectorios();
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar el directorio",
          });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
  mounted() {
    this.initConfiguracion();
  },
};
</script>

<style>
</style>